<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <Alert banner closable>搜索支持全局搜索，多条件搜索时请使用“|”作为条件分隔符</Alert>
          <div class="search-con search-con-top">

            <el-row :gutter="15" style="margin: 10px;">
              <el-col :lg="8">
                <el-card shadow="never">
                  <sc-statistic  title="当日指标" :value="kpi_day" :description="'月指标：'+kpi" ></sc-statistic>
                </el-card>
              </el-col>
              <el-col :lg="8">
                <el-card shadow="never">
                  <sc-statistic title="已完成" :value="count_ok_day" :description="'月总数：'+ count_ok"  >
                  </sc-statistic>
                </el-card>
              </el-col>
              <el-col :lg="8">
                <el-card shadow="never">
                  <sc-statistic title="完成率" :value="ok_percent_day" suffix="%" :description="'总：'+ok_percent + '%'" >
                  </sc-statistic>
                </el-card>
              </el-col>
            </el-row>
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入关键字全局搜索"
                   @on-enter="searchinput"/>
            <DatePicker
              v-model="searchVal_year"
              type="year"
              @on-change="searchinput"
              placeholder="选择年">
            </DatePicker>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>

<!--          <Table v-loading.fullscreen.lock="fullscreenLoading" height="670" size="small" ref="selection" border-->
<!--                 :columns="columns" :data="tableData"-->
<!--                 @on-selection-change="handleSelectChange"></Table>-->
          <el-table
            :data="tableData" border
            style="width: 100%" size="small">
            <el-table-column type="expand">
              <template slot-scope="props">
                <el-divider content-position="left">援助记录</el-divider>
                <el-table
                  size="small"
                  :data="props.row.his"
                  style="width: 100%"
                  max-height="300"
                  border
                  :row-style="{height:'33px'}"
                  :cell-style="{padding:'0px'}"
                >
                  <el-table-column
                    type="index"
                    label="序号"
                    width="50"
                    align="center"
                    fixed>
                  </el-table-column>
                  <el-table-column
                    prop="assist_time"
                    label="援助时间"
                    width="250"
                    align="center"
                    fixed>
                  </el-table-column>
                  <el-table-column
                    prop="atype_CN"
                    label="援助类型"
                    width="150"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="assist_content"
                    label="援助内容"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="remark"
                    label="备注"
                    width="100"
                    align="center">
                  </el-table-column>
                  <el-table-column
                    show-overflow-tooltip
                    prop="suser"
                    label="业务员"
                    width="100"
                    align="center">
                  </el-table-column>
                  <el-table-column align="center" width="120">
                    <template slot="header" slot-scope="scope">
                      操作
                    </template>
                    <template slot-scope="scope">
                      <el-button type="primary" icon="el-icon-edit" circle @click="editbusinessModal(scope.row, 'post', '修改援助信息', props.row)" ></el-button>
                      <el-button
                        type="danger" icon="el-icon-delete" circle @click="delData(scope, props.row.his)" ></el-button>
                    </template>

                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
              label="个人编号" align="center" width="110"
              prop="perno" sortable>
            </el-table-column>
            <el-table-column
              label="姓名" align="center" width="100"
              prop="pname" sortable>
            </el-table-column>
            <el-table-column
              label="性别" align="center" width="80"
              prop="sex_CN" sortable>
            </el-table-column>
            <el-table-column
              label="身份证号" align="center"
              prop="idcard" sortable>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="文化程度" align="center" width="100"
              prop="pedu_CN" sortable>
            </el-table-column>
            <el-table-column
              label="联系电话" align="center"
              prop="phone" sortable>
            </el-table-column>
            <el-table-column
              label="人员类型" align="center"
              prop="type_CN" sortable>
            </el-table-column>
            <el-table-column
              label="年度" align="center" width="100"
              prop="year" sortable>
            </el-table-column>
<!--            <el-table-column-->
<!--              label="月份" align="center" width="100"-->
<!--              prop="month" sortable>-->
<!--            </el-table-column>-->
            <el-table-column
              label="服务次数" align="center" width="100"
              prop="s_count" sortable>
            </el-table-column>
            <el-table-column
              label="资料完整度" align="center" width="120"
              prop="info_percent" sortable>
            </el-table-column>
            <el-table-column
              label="状态" align="center" width="100"
              prop="state_CN" sortable>
            </el-table-column>
            <el-table-column align="center" width="300">
              <template slot="header" slot-scope="scope">
                操作
              </template>
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="primary"
                  @click="showonetoone(scope.row.id)">一人一档</el-button>
                <el-button
                  size="small"
                  type="primary"
                  @click="editModal(scope.row, 'post', '就业帮扶人员基本情况表')">基本情况</el-button>
                <el-button
                  size="small"
                  type="primary"
                  @click="businessModal(scope.row, 'post', '就业援助')">援助服务</el-button>
              </template>

            </el-table-column>

          </el-table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="formValidate" :model="formValidate" :label-width="100">
              <FormItem
                label="户籍所属"
                prop="account"
              >
                <el-select
                  v-model="formValidate.account"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="如列表未包含，可直接输入，格式：乡镇社区">
                  <el-option
                    v-for="item in accountList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="姓名"
                prop="pname"
              >
                <Input
                  v-model="formValidate.pname"
                  placeholder="请输入姓名" disabled
                ></Input>
              </FormItem>
              <FormItem
                label="性别"
                prop="sex"
              >
                <el-select
                  v-model="formValidate.sex"
                  filterable  disabled
                  default-first-option
                  placeholder="请选择性别">
                  <el-option
                    v-for="item in sexList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="身份证号"
                prop="idcard"
              >
                <Input
                  v-model="formValidate.idcard"
                  placeholder="请输入身份证号" disabled
                ></Input>
              </FormItem>
              <FormItem
                label="文化程度"
                prop="pedu"
              >
                <el-select
                  v-model="formValidate.pedu"
                  filterable
                  default-first-option
                  placeholder="请选择文化程度">
                  <el-option
                    v-for="item in peduList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem
                label="联系电话"
                prop="phone"
              >
                <Input
                  v-model="formValidate.phone"
                  placeholder="请输入联系电话"
                ></Input>
              </FormItem>
              <FormItem
                label="户籍地址"
                prop="account_address"
              >
                <Input
                  v-model="formValidate.account_address"
                  placeholder="请输入户籍地址"
                ></Input>
              </FormItem>
              <FormItem
                label="家庭住址"
                prop="home_address"
              >
                <Input
                  v-model="formValidate.home_address"
                  placeholder="请输入家庭住址"
                ></Input>
              </FormItem>
              <FormItem
                label="援助对象类型"
                prop="assisttype"
              >
                <CheckboxGroup v-model="formValidate.assisttype" v-for="item in assisttypeList">
                  <Checkbox  :label="item.meaning" :key="item.value" border style="margin-top: 5px"></Checkbox>
                </CheckboxGroup>
              </FormItem>
              <FormItem
                label="家庭情况"
                prop="family"
              >
                <Input
                  v-model="formValidate.family"
                  placeholder="请输入家庭情况"
                ></Input>
              </FormItem>
              <FormItem
                label="个人情况"
                prop="person"
              >
                <Input
                  v-model="formValidate.person"
                  placeholder="请输入个人情况"
                ></Input>
              </FormItem>
              <FormItem
                label="培训意向"
                prop="hobbies"
              >
                <Input
                  v-model="formValidate.hobbies"
                  placeholder="请输入培训意向"
                ></Input>
              </FormItem>
              <FormItem
                label="职业能力"
                prop="competence"
              >
                <Input
                  v-model="formValidate.competence"
                  placeholder="请输入职业能力"
                ></Input>
              </FormItem>
              <FormItem
                label="就业意愿"
                prop="will"
              >
                <Input
                  v-model="formValidate.will"
                  placeholder="请输入就业意愿"
                ></Input>
              </FormItem>
              <FormItem
                label="备注"
                prop="reasons"
              >
                <Input
                  v-model="formValidate.reasons"
                  placeholder="请输入备注"
                ></Input>
              </FormItem>

              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmit('formValidate')"
                >提交
                </Button>
                <Button
                  @click="handleReset('formValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
          <Modal v-model="onetoneVisble" :title="onetoneTitle" :loading=true :footer-hide=true
                 :width="900"
                 :mask-closable=false>
            <iframe
              :src="'https://ljtc.tcrc.com.cn/webroot/decision/view/report?viewlet=yryd.cpt&ref_t=design&op=view&id='+onerowid"
              id="mobsf" width="100%" height="600" scrolling="no" frameborder="0"></iframe>

          </Modal>
          <Modal v-model="business.modalVisible" :title="business.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false>
            <Form ref="businessValidate" :model="businessValidate"  :label-width="100">

              <FormItem label="援助类型" prop="atype">
                <el-select
                  v-model="businessValidate.atype"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择援助类型">
                  <el-option
                    v-for="item in atypelist"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="援助时间" prop="assist_time">
                <DatePicker  type="date" editable v-model="businessValidate.assist_time" format="yyyy-MM-dd" placement="bottom-end" placeholder="请选择援助时间" ></DatePicker>
              </FormItem>
              <FormItem label="服务类型" prop="stype">
                <el-select
                  v-model="businessValidate.stype"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择服务类型">
                  <el-option
                    v-for="item in stypelist"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem label="援助内容">
                <Input v-model="businessValidate.assist_content" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入援助内容" />
              </FormItem>
              <FormItem label="备注">
                <Input v-model="businessValidate.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注" />
              </FormItem>
              <FormItem label="人员状态" prop="state">
                <el-select
                  v-model="businessValidate.state"
                  filterable
                  default-first-option
                  placeholder="请选择服务类型">
                  <el-option
                    v-for="item in stateList"
                    :key="item.value"
                    :label="item.meaning"
                    :value="item.value">
                  </el-option>
                </el-select>
              </FormItem>
              <FormItem>
                <Button
                  type="primary"
                  @click="handleSubmitBuss('businessValidate')"
                >提交
                </Button>
                <Button
                  @click="handleResetBuss('businessValidate')"
                  style="margin-left: 8px"
                >重置
                </Button>
              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>

import {
  getAssistkpilist,
  importexceldata, operationAssistInfo, operationAssistkpi, operationAssistperson,
} from '@/api/assist/assistperson.js'
import {getsysparameterList} from "@/api/system/sys_parameter";
import excel from "@/libs/excel";
import scStatistic from "./scStatistic/index.vue";
import {float, str} from "mockjs/src/mock/random/basic";
import {round} from 'echarts/lib/util/number'

let moment = require("moment");
export default {
  components: {
    'sc-statistic':scStatistic
  },
  data() {
    return {
      onetoneVisble:false,
      onerowid:0,
      onetoneTitle:'一对一就业帮扶人员基本情况表',
      assisttypeList:[],
      month:'指标 >> 2023.10',
      spinShow: false,
      fullscreenLoading: false,
      sexList: [],
      peduList: [],
      difftypeList: [],
      typeList: [],
      accountList:[],
      accounttypeList: [],
      untypeList: [],
      getinsuranceList: [],
      stateList: [],
      formValidate: {},
      kpi: '0',
      count_ok: '0',
      ok_percent: '0',
      kpi_day: '0',
      count_ok_day: '0',
      ok_percent_day: '0',
      searchVal: "",
      searchVal_year: "",
      showProgress: false,
      progressPercent: 0,
      loadingProgress: 0,
      file: null,
      showRemoveFile: false,
      uploadLoading: false,
      tableData: [],
      tableDatatmp: [],
      tableTitle: [],
      tableLoading: false,
      showre: false,
      showretxt: '',
      modalMap: {
        modalVisible: false,
        modalTitle: "新建"
      },
      business:{
        modalVisible: false,
        modalTitle: "新建",
        meth:'post'
      },
      businessValidate:{},
      atypelist:[],
      stypelist:[],
      tableSelectIdList: [],
      editModalData: "",
      pageNum: 1, // 当前页码
      pageTotal: 0, // 数据总数
      pageSize: 15, // 每页条数

    };
  },
  methods: {
    isItemChecked(item) {
      // 如果item在formValidate.assisttype中，返回true，否则返回false
      console.log(this.formValidate.assisttype)
      console.log(item)
      if (this.formValidate.assisttype){
        return this.formValidate.assisttype.includes(item.value);
      }else{
        return false
      }

    },
    getAssistkpilist(key, value) {
      this.spinShow = true
      if (this.searchVal_year != ''){
        value = this.searchVal_year
        if (value instanceof Date) {
          value = value.getFullYear().toString(); // 提取年份并转换为字符串
        }
      }
      getAssistkpilist(this.pageNum, this.pageSize, key, value).then(res => {
        if (res.data.code === 0) {
          this.month = '指标 >> '+res.data.month
          this.kpi = res.data.kpi.toString()
          this.kpi_day = res.data.day_kpi.toString()
          this.count_ok = res.data.docount.toString()
          this.count_ok_day = res.data.docount_day.toString()
          if (res.data.kpi!=0){
            this.ok_percent = round((parseFloat(res.data.docount)/parseFloat(res.data.kpi))*100,2).toString()
          }else{
            this.ok_percent = '-'
          }
          if (res.data.day_kpi!=0){
            this.ok_percent_day = round((parseFloat(res.data.docount_day)/parseFloat(res.data.day_kpi))*100,2).toString()
          }else{
            this.ok_percent_day = '-'
          }
          this.pageTotal = res.data.count
          this.tableData = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
        this.spinShow = false
      })
    },
    getParameterList() {
      getsysparameterList('assist_person', 'sex').then(res => {
        if (res.data.code === 0) {
          this.sexList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('assist_person', 'pedu').then(res => {
        if (res.data.code === 0) {
          this.peduList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })


      getsysparameterList('assist_archives', 'account').then(res => {
        if (res.data.code === 0) {
          this.accountList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('assist_archives', 'assisttype').then(res => {
        if (res.data.code === 0) {
          this.assisttypeList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })

    },
    getbusParameterList() {
      getsysparameterList('assist_person', 'state').then(res => {
        if (res.data.code === 0) {
          this.stateList = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('assist_info', 'stype').then(res => {
        if (res.data.code === 0) {
          this.stypelist = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })
      getsysparameterList('assist_info', 'atype').then(res => {
        if (res.data.code === 0) {
          this.atypelist = res.data.data
        } else {
          this.$Message.error(`${res.data.msg}`)
        }
      })

    },
    handleSelectChange(val) {
      let SelectIdList = []
      val.forEach(item => {
        SelectIdList.push(item.id)
      })
      this.tableSelectIdList = SelectIdList
    },
    closeModal() {
      this.dialog.show = false
    },
    inttostr(int){
      if (int != null){
        return int.toString()
      }else{
        return ''
      }
    },
    delData (params, tabledata) {
      console.log(params)
      if (confirm(`确定要删除该信息吗？`)) {
        operationAssistInfo(
          {
            'id': params.row.id
          },
          'delete'
        ).then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`)
            tabledata.splice(params.index, 1)
          } else {
            this.$Message.error(`${res.data.msg}`)
          }
        })
      }
    },
    businessModal(paramsRow, meth, mtitle) {
      this.business.modalVisible = true;
      this.business.modalTitle = mtitle;
      this.business.meth = meth;
      this.getbusParameterList();
      var day2 = new Date();
      day2.setTime(day2.getTime());
      var s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate() + " " + day2.getHours() + ":" + day2.getMinutes() + ":" + day2.getSeconds();
      if (paramsRow && paramsRow.id) {
        this.businessValidate = {
          aid: paramsRow.id,
          assist_time: s2,
          atype: '1',
          stype: '1',
          assist_content: '',
          remark: '',
          state: this.inttostr(paramsRow.state)
        }
      }
    },

    editbusinessModal(paramsRow, meth, mtitle, parentdata) {
      // console.log(parentdata)
      this.business.modalVisible = true;
      this.business.modalTitle = mtitle;
      this.business.meth = meth;
      this.getbusParameterList();
      var day2 = new Date();
      day2.setTime(day2.getTime());
      var s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate() + " " + day2.getHours() + ":" + day2.getMinutes() + ":" + day2.getSeconds();
      if (paramsRow && paramsRow.id) {
        this.businessValidate = {
          id: paramsRow.id,
          aid: paramsRow.aid,
          assist_time: paramsRow.assist_time,
          atype: this.inttostr(paramsRow.atype),
          stype: this.inttostr(paramsRow.stype),
          assist_content: paramsRow.assist_content,
          remark: paramsRow.remark,
          state: this.inttostr(parentdata.state)
        }
      }
    },
    nickName () {
      // console.log(this.$store)
      return this.$store.state.user.userId
    },
    showonetoone(id){
      this.onetoneVisble = true
      this.onerowid = id
    },
    editModal(paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true;
      this.modalMap.modalTitle = mtitle;
      this.editModalData = meth;
      this.getParameterList();
      var day2 = new Date();
      day2.setTime(day2.getTime());
      var s2 = day2.getFullYear() + "-" + (day2.getMonth() + 1) + "-" + day2.getDate() + " " + day2.getHours() + ":" + day2.getMinutes() + ":" + day2.getSeconds();
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          perno: paramsRow.perno,
          pname: paramsRow.pname,
          sex: this.inttostr(paramsRow.sex),
          idcard: paramsRow.idcard,
          pedu: this.inttostr(paramsRow.pedu),
          phone: paramsRow.phone,
          account: paramsRow.account,
          account_address: paramsRow.accaddress,
          home_address: paramsRow.nowaddress
        }
          if (paramsRow.archives){
            this.formValidate.account = this.inttostr(paramsRow.archives.account)
            this.formValidate.account_address = paramsRow.archives.account_address
            this.formValidate.home_address = paramsRow.archives.home_address
            this.formValidate.assisttype = paramsRow.archives.assisttype_CN
            this.formValidate.family = paramsRow.archives.family
            this.formValidate.person = paramsRow.archives.person
            this.formValidate.hobbies = paramsRow.archives.hobbies
            this.formValidate.competence = paramsRow.archives.competence
            this.formValidate.will = paramsRow.archives.will
            this.formValidate.reasons = paramsRow.archives.reasons
          }
      }
    },
    handleSubmit(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.formValidate.untime = moment(this.formValidate.untime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss');
            this.formValidate.unregtime = moment(this.formValidate.unregtime).utcOffset(480).format('YYYY-MM-DD HH:mm:ss');
            operationAssistkpi(this.formValidate, this.editModalData).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getAssistkpilist(this.searchVal)
                } else {
                  this.getAssistkpilist()
                }
                this.modalMap.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error("缺少必要参数");
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    handleSubmitBuss(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.businessValidate.assist_time = moment(this.businessValidate.assist_time).utcOffset(480).format('YYYY-MM-DD HH:mm:ss');
            operationAssistInfo(this.businessValidate, this.business.meth).then(res => {
              if (res.data.code === 0) {
                this.$Message.success(`${res.data.msg}`)
                if (this.searchVal) {
                  this.getAssistkpilist(this.searchVal)
                } else {
                  this.getAssistkpilist()
                }
                this.business.modalVisible = false
              } else {
                this.$Message.error(`${res.data.msg}`)
              }
            })
          }, 1000)
        } else {
          this.$Message.error("缺少必要参数");
        }
      })
    },
    handleResetBuss(name) {
      this.$refs[name].resetFields();
    },

    changePage(value) {
      this.pageNum = value
      if (this.searchVal) {
        this.getAssistkpilist(this.searchVal)
      } else {
        this.getAssistkpilist()
      }
    },
    handlePageSize(value) {
      this.pageSize = value
      this.pageNum = 1
      if (this.searchVal) {
        this.getAssistkpilist(this.searchVal)
      } else {
        this.getAssistkpilist()
      }
    },
    searchinput() {
      if (this.searchVal) {
        this.getAssistkpilist(this.searchVal)
      } else {
        this.getAssistkpilist()
      }
    },
    handleRemove() {
      this.showProgress = false
      this.showre = false
      this.initUpload()
      this.$Message.info('上传的文件已删除！')
    },
    handlerimport() {
      if (this.tableDatatmp.length > 0) {
        this.uploadLoading = true
        importexceldata({'data_list': this.tableDatatmp, 'filename': this.file.name}, 'post').then(
          res => {
            this.progressPercent = 101
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`)
              this.showre = true
              this.showretxt = res.data.msg
              this.uploadLoading = false
              this.getAssistkpilist(this.searchVal)
            } else {
              this.$Message.error(`${res.data.msg}`)
            }
          })
        this.uploadLoading = false
      }

    },
    readFile(file) {
      const reader = new FileReader()
      reader.readAsArrayBuffer(file)
      reader.onloadstart = e => {
        this.uploadLoading = true
        this.tableLoading = true
        this.showProgress = true
      }
      reader.onprogress = e => {
        this.progressPercent = Math.round(e.loaded / e.total * 100)
      }
      reader.onerror = e => {
        this.$Message.error('文件读取出错')
      }
      reader.onload = e => {
        this.$Message.info('文件读取成功')
        this.progressPercent = 100
        const data = e.target.result
        const {header, results} = excel.read(data, 'array')
        const tableTitle = header.map(item => {
          return {title: item, key: item}
        })
        this.tableDatatmp = results
        this.tableTitle = tableTitle
        this.uploadLoading = false
        this.tableLoading = false
        this.showRemoveFile = true
        // this.showProgress = false

      }
    },
    handleBeforeUpload(file) {
      const fileExt = file.name.split('.').pop().toLocaleLowerCase()
      if (fileExt === 'xlsx' || fileExt === 'xls') {
        this.readFile(file)
        this.uploadLoading = true
        this.tableLoading = true
        this.showProgress = true
        this.file = file
      } else {
        this.$Notice.warning({
          title: '文件类型错误',
          desc: '文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。'
        })
      }
      return false
    },
    handleUploadFile() {
      this.initUpload()
    },
    initUpload() {
      this.file = null
      this.showProgress = false
      this.loadingProgress = 0
      this.tableDatatmp = []
      this.tableTitle = []
    },
  },
  watch: {
    searchVal(val) {
      this.searchVal = val
    }
  },
  mounted() {
    this.getAssistkpilist();
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col {
      display: inline-block;
      width: 200px;
    }
    &-input {
      display: inline-block;
     width: 200px;
      margin-left: 2px;
    }
    &-btn {
      margin-left: 2px;
    }
  }
}
</style>
